import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { privateRoot } from 'routes/paths';
import TitlePage from 'components/TituloPage';
import Filtro from 'containers/Relatorios/filtro';
import RelatorioTipoResumido from 'containers/Relatorios/relatorioResumido/tipoResumido';
import RelatorioDetalhada from 'containers/Relatorios/relatorioDetalhado/tabelaRelDetalhada';
import { fetchGetTodosAssuntos } from 'store/fetchActions/fetchInputForm';
import { fetchGetTodosServicos } from 'store/fetchActions/fetchServico';
import { fetchGetRelatorioGrafico } from 'store/fetchActions/fetchRelatorios';
import { ENUM_TIPO_RELATORIO } from 'utils/consts';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import * as S from './styles';
import * as Style from 'components/Style';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { fetchBuscarSetores } from 'store/fetchActions/fetchSetores';

export default function PageRelatorioTipo() {
  const tipoRelatorio = ENUM_TIPO_RELATORIO.TIPO;
  const dispatch = useDispatch();

  const user = useSelector(state => state.sefaz.userProfile);
  const inputSelectOptionsSetores = useSelector(state => state.inputs.inputSelectOptionsSetores);
  const { todosAssuntos, inputSelectOptionsSolicitacoes } = useSelector(state => state.inputs);

  const [filtroSelecionado, setFiltroSelecionado] = useState({});
  const [dadosGrafico, setDadosGrafico] = useState(null);
  const [dadosGrid, setDadosGrid] = useState(null);

  const fraseSupervisor = `O gráfico mostra a quantidade de requerimentos que foram abertos, fechados e estão pendentes (Em Análise - Em Atendimento - Encaminhados - Direcionados) no período selecionado,
  para visualizar ou exportar os dados preencha o filtro.`;

  const fraseSupervisorSetorial = `O gráfico mostra a quantidade de requerimentos que foram fechados e estão pendentes (Em Análise - Em Atendimento - Encaminhados - Direcionados) no período selecionado,
  para visualizar ou exportar os dados preencha o filtro.`;

  const pesquisarDados = filtro => {
    dispatch(fetchGetRelatorioGrafico(filtro))
      .then(res => {
        setDadosGrid(null);
        setDadosGrafico(res);
      })
      .catch(() => setDadosGrafico(null));
  };

  React.useEffect(() => {
    if (user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL) dispatch(fetchBuscarSetores(false));
    dispatch(fetchGetTodosAssuntos(todosAssuntos));
    dispatch(fetchGetTodosServicos(inputSelectOptionsSolicitacoes));
    // eslint-disable-next-line
  }, [user, dispatch]);

  const clearDados = () => {
    setDadosGrafico(null);
  };

  const pesquisarDadosGridTipo = () => {
    dispatch(fetchGetRelatorioGrafico({ ...filtroSelecionado, TabelaSolicitacao: true })).then(res =>
      setDadosGrid(res.periodo)
    );
  };

  return (
    <S.Page>
      <TitlePage textTitle={'Relatório por Tipo'} backPage={privateRoot} />
      <Filtro
        salvarFiltro={setFiltroSelecionado}
        funcPesquisar={pesquisarDados}
        tipoRelatorio={tipoRelatorio}
        cleanDadosGrafico={clearDados}
        dadosGrafico={dadosGrafico}
        filtro={filtroSelecionado}
        relatorioNome={'Relatorio_por_tipo'}
        todosAssuntos={montarDadosInputSelect([...todosAssuntos, { id: 0, descricao: 'Geral' }], 'id', 'descricao')}
        todosServicos={montarDadosInputSelect(inputSelectOptionsSolicitacoes, 'id', 'nome')}
        showInputAssunto={true}
        showInputSetor={user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL}
        todosSetores={montarDadosInputSelect(inputSelectOptionsSetores, 'id', 'nome')}
      />

      <Style.GlobalCard>
        <S.Descricao>
          <h2>Relatório dos Requerimentos por Tipo</h2>
          <p>{user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL ? fraseSupervisorSetorial : fraseSupervisor}</p>
          <p>{`Cada requerimento é aberto com um assunto específico, no caso da seleção do assunto 'Acessos aos Serviços' será apresentada a possibilidade de selecionar quais serviços serão apresentados no gráfico.`}</p>
        </S.Descricao>
        <RelatorioTipoResumido
          filtroSelecionado={filtroSelecionado}
          dadosGrafico={dadosGrafico}
          todosAssuntos={todosAssuntos}
          isSetorial={user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL}
        />
        <RelatorioDetalhada
          dadosGrid={dadosGrid}
          mostrarDados={pesquisarDadosGridTipo}
          dadosGrafico={dadosGrafico}
          isSetorial={user?.profile === ENUM_TIPO_PERFIL.SUPERVISOR_SETORIAL}
        />
      </Style.GlobalCard>
    </S.Page>
  );
}
